import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { useDialog } from '@ts-core/components/Dialog';
import { useSubjectsPanel } from '@ts-core/components/SubjectsPanel';

import { useSubjectActions } from '../../hooks';

export default function useProfessorSubjectsPanel({ courseId, showSelectedMark = false, selectedSubjectId, onSelectLeafSubject }) {
  const intl = useIntl();

  const { onCloseDialog, onOpenDialog, dialogProps } = useDialog();

  const {
    subjects,
    loading,
    error,
    onCreateSubject,
    creatingSubject,
    onUpdateSubject,
    updatingSubject,
    onDeleteSubject,
    onToggleSubject,
    onReorderSubject,
  } = useSubjectActions({
    courseId,
    onSubjectCreated: onCloseDialog,
    onSubjectUpdated: onCloseDialog,
  });

  const onAddSubject = useCallback(
    (subject) => {
      onOpenDialog({
        title: intl.formatMessage({ id: 'dialog.addSubject.title' }),
        dialogData: {
          subject: {
            parentSubject: subject?._id,
            order: subject?.subjects?.length || subjects.length,
          },
        },
      });
    },
    [onOpenDialog, subjects, intl]
  );

  const onEditSubject = useCallback(
    (subject) => {
      onOpenDialog({
        title: intl.formatMessage({ id: 'dialog.editSubject.title' }),
        dialogData: {
          subject,
        },
      });
    },
    [onOpenDialog, intl]
  );

  const coreSubjectPanelProps = useSubjectsPanel({
    subjects,
    loading,
    error,
    selectedSubjectId,
    showSelectedMark,
    addingSubject: creatingSubject,
    editingSubject: updatingSubject,
    onSelectLeafSubject,
    onAddSubject,
    onEditSubject,
    onRemoveSubject: onDeleteSubject,
    onToggleSubject,
    onReorderSubject,
  });

  return { ...coreSubjectPanelProps, onCreateSubject, onUpdateSubject, dialogProps };
}
